import {
	ArrayUnique,
	IsArray,
	IsBoolean,
	IsDateString,
	IsEmail,
	IsEnum,
	IsOptional,
	IsString,
	IsUUID,
	ValidateIf,
} from 'class-validator';
import {
	AppToastType,
	NotificationChannel,
	NotificationTargetAudience,
	NotificationType,
} from '../../enums';

export class MarkNotificationReadDto {
	@IsUUID()
	id: string;

	@IsBoolean()
	is_read: boolean;

	@IsEmail()
	@IsString()
	email: string;
}

export class UpdateNotificationDto {
	@IsUUID()
	id: string;

	@IsOptional()
	@IsBoolean()
	is_active: boolean;
}

export class LogClientEventDto {
	@IsString()
	event: string;

	@IsOptional()
	@IsString()
	level?: string;
}

export class CreateSelfNotificationDto {
	@IsString()
	title: string;

	@IsString()
	message: string;

	@IsOptional()
	@IsString()
	link?: string;

	@IsOptional()
	@IsEnum(NotificationType)
	type?: NotificationType;
}

export class CreateNotificationForEventDto {
	@IsString()
	title: string;

	@IsString()
	message: string;

	@IsOptional()
	@IsEnum(NotificationType)
	type?: NotificationType;

	@IsOptional()
	@IsString()
	link?: string;

	@IsEnum(NotificationChannel)
	channel: NotificationChannel;

	@IsBoolean()
	is_active: boolean;

	@IsBoolean()
	is_global: boolean;

	@ValidateIf((o) => o.is_global)
	@IsOptional()
	@IsEnum(NotificationTargetAudience)
	target_audience?: NotificationTargetAudience;

	@ValidateIf((o) => !o.is_global)
	@IsArray()
	@ArrayUnique()
	@IsEmail({}, { each: true })
	target_users?: string[];

	@IsBoolean()
	is_event_wide: boolean;

	@ValidateIf((o) => !o.is_event_wide)
	@IsArray()
	@ArrayUnique()
	@IsUUID('4', { each: true })
	lobby_ids?: string[];

	@IsOptional()
	@IsEnum(AppToastType)
	toast_type?: AppToastType;

	@IsOptional()
	@IsDateString()
	expire_date?: string | null;

	@IsOptional()
	@IsDateString()
	scheduled_date?: string | null;
}
